import React from 'react'
import Link from './../../components/Link'

export default ({ isCurrent, _id = null, name, isLast = false, onClick, classPrefix }) => (
  <span>
    { isCurrent ? <span className={`${classPrefix}__Link_active`}>{name}</span> : <Link className={`Link ${classPrefix}__Link`} onClick={onClick.bind(this, _id)}>{name}</Link> }
    { !isLast && `, ` }
  </span>
)



// WEBPACK FOOTER //
// ./src/containers/Categories/Item.jsx